export default "__VITE_ASSET__4b5c55d3__"